import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_ROUTE_POINTS')
};

export default TYPES;
